import { FC, ReactNode } from "react";
import Typography from "../Typography";

type AnswerBlockProps = {
  heading: ReactNode;
  body: ReactNode;
  specs: { label: string; value: ReactNode }[];
  updated: string;
};

// The direct answer and spec table every money page opens with, so the first
// thing crawlers and LLMs read answers the query with facts. A plain table
// rather than cards: it survives text extraction with labels and values
// still paired.
const AnswerBlock: FC<AnswerBlockProps> = ({
  heading,
  body,
  specs,
  updated,
}) => {
  return (
    <section className="max-w-4xl px-3 md:px-12 mx-auto my-24">
      <Typography variant="h3" component="h2">
        {heading}
      </Typography>
      <Typography variant="body1" className="mt-6 text-slate-600">
        {body}
      </Typography>
      <div className="mt-10 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <table className="w-full text-left">
          <tbody className="divide-y divide-slate-200">
            {specs.map((spec) => (
              <tr key={spec.label}>
                <th
                  scope="row"
                  className="w-1/3 px-5 py-4 align-top font-display text-sm font-medium text-slate-900"
                >
                  {spec.label}
                </th>
                <td className="px-5 py-4 align-top font-display text-sm text-slate-600 leading-relaxed">
                  {spec.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Typography variant="caption" className="mt-4 text-slate-500">
        {updated}
      </Typography>
    </section>
  );
};

export default AnswerBlock;
